import {IFreeToPlayService, IFreeToPlayShowOptions} from "./free-to-play.service.interface";
import {AnimatedIconBaseService, AnimatedIconObservableTarget} from "../pixi-app/animated-icon-base-service.service";
import { IServiceFactoryExtended } from "../service-factory-extended.interface";
import { observable, action } from "mobx";
import { Check } from "@sparkware/app-utils";

export class FreeToPlayService extends AnimatedIconBaseService implements IFreeToPlayService {
    constructor(serviceFactory: IServiceFactoryExtended) {
        super(serviceFactory);

        this.reaction(() => this.services.user.isAuthorized,
        async () => {
            let isPromotionEligible = false;
            if (this._isEnabled()) {
                //isPromotionPermitted means user want to receive all promotions - including F2P one
                let isPromotionPermitted = false;
                if (this.services.user.isAuthorized) {
                    isPromotionPermitted = this.services.user.userData.IsPromotionPermitted;
                    if (Check.isNullOrUndefined(isPromotionPermitted)) {
                        isPromotionPermitted = true;
                    }
                }
                isPromotionEligible = this._isEnabled() && isPromotionPermitted;
            }
            this._setIsPromotionEligible(isPromotionEligible);
        }, {
            fireImmediately: true
        });        
    }

    @observable
    private _isPromotionEligible: boolean = false;

    @action
    private _setIsPromotionEligible(isEligible: boolean) {
        this._isPromotionEligible = isEligible;
    }


    get isPromotionEligible(): boolean {
        return this._isPromotionEligible;
    }

    @observable
    private _isPromotionOpened: boolean = false;
    
    get isPromotionOpened(): boolean {
        return this._isPromotionOpened;
    }

    @action
    setIsPromotionOpened(isOpened: boolean) {
        this._isPromotionOpened = isOpened;
    }

    loadFreeToPlayAnimation(options: AnimatedIconObservableTarget) {
        this.loadAnimatedIcon(options, "freeToPlayAnimatedIcon");
    }

    get iconIndex(): number {
        const abIndex = this.services.abTestingFeatureDataProvider.free2PlayIconNumber;
        return abIndex >= 1 && abIndex <= 2 ? abIndex : 2;
    }

    private _isEnabled(): boolean {
        return this.services.configuration.servicesConfigs.AppLauncher.apps.CASINO_BONUS_GAME_WIDGET.enabled;
    }

    showPromotion(options: IFreeToPlayShowOptions): Promise<void> {
        return this.services.appLauncher.openFreeToPlayBonusGames({
            businessCorrelationID: this.services.tools.getGuid(),
            sequentialCorrelationID: 1,
            channel: options.channel,
            appSpecificParameters: options.appSpecificParameters
        });
    }
}
